import React from 'react';
import { Link } from 'react-router-dom';

const BlogRow = ({blog}) => {
    return (
       <Link to={`/blogdetails/${blog._id}`}> <div className='p-3 bg-white shadow-xl group  cursor-pointer w-full border'>
            <div className='w-full h-44 md:h-56 rounded relative overflow-hidden bg-no-repeat bg-cover'>
                <img
                    src={blog.image}
                    alt=""
                    className='w-full h-44 md:h-56 rounded group-hover:scale-110 transition duration-300 ease-in-out' />
            </div>
            <div className="p-2">
                <div className='flex items-center gap-5 text-gray-500 pt-3 pb-2'>
                    <h3 className='text-xs md:text-sm'><i class="fa-regular fa-user pr-1"></i> Jack lessons</h3>
                    <h3 className='text-xs md:text-sm'><i class="fa-regular fa-calendar-days pr-1"></i> 13 January 2023</h3>
                </div>
                <h3 className=' md:text-lg font-semibold  text-gray-600 '>{blog.title.slice(0, 25)}</h3>
            </div>
        </div></Link>
    );
};

export default BlogRow;